/* eslint-disable no-unreachable */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import ModalWrapper from 'components/Modals/ModalWrapper';
import { RenderDatePicker } from 'components/Common/Inputs/RenderDatePicker';
import DateTimes from 'components/Common/DateTimes';

const required = value => !value || !value.target || !value.target.value || !value.target.value.trim();

class MICustomDateRange extends Component {
  static propTypes = {
    isShown: PropTypes.bool,
    onCancel: PropTypes.func,
    onClose: PropTypes.func
  };

  static defaultProps = {
    isShown: false,
    onCancel: null,
    onClose: null
  };

  constructor(props) {
    super(props);
    this.state = {
      dateRangeFrom: null,
      dateRangeTo: null
    };
  }

  handleDateFromChange(event, newValue, oldValue) {
    this.setState({ dateRangeFrom: newValue });
  }

  handleDateToChange(event, newValue, oldValue) {
    this.setState({ dateRangeTo: newValue });
  }

  handleClose() {
    const { dateRangeFrom, dateRangeTo } = this.state;
    const { onClose } = this.props;
    onClose(dateRangeFrom, dateRangeTo);
  }

  isDateSelectionValid() {
    const { dateRangeFrom, dateRangeTo } = this.state;
    return !!dateRangeFrom && !!dateRangeTo;
  }

  render() {
    const { dateRangeFrom, dateRangeTo } = this.state;
    const { isShown, onCancel } = this.props;
    return (
      <ModalWrapper
        isOpen={ isShown }
        title="Select Custom Reporting Period"
        onCancel={ onCancel }
        onConfirm={ () => this.handleClose() }
        formId="customReportingPeriodModal"
        btnConfirmTitle="Apply"
        disableConfirm={ () => !this.isDateSelectionValid() }
      >
        <form
          className="form-horizontal"
          id="custom-date-form"
        >
          <div className="form-group">
            <div className="col-4">
              <label htmlFor="date-from" className="form-label">FROM *</label>
            </div>
            <div className="full-width-datepicker col-8">
              <Field
                id="date-from"
                name="dateFrom"
                component={ RenderDatePicker }
                { ...{ maxDate: DateTimes.today } }
                className="form-input"
                placeholder="MMM DD, YYYY"
                dateFormat="MMM dd yyyy"
                required
                value={ dateRangeFrom }
                validate={ required }
                onChange={ (e, newValue, previousValue) => this.handleDateFromChange(e, newValue, previousValue) }
              />
            </div>
          </div>
          <div className="form-group">
            <div className="col-4">
              <label htmlFor="date-to" className="form-label">TO *</label>
            </div>
            <div className="full-width-datepicker col-8">
              <Field
                id="date-to"
                name="dateTo"
                component={ RenderDatePicker }
                { ...{ maxDate: DateTimes.today } }
                className="form-input"
                placeholder="MMM DD YYYY"
                required
                value={ dateRangeTo }
                validate={ required }
                onChange={ (e, newValue, previousValue) => this.handleDateToChange(e, newValue, previousValue) }
              />
            </div>
          </div>
          <div className="form-group">
            <div className="col-4">&nbsp;</div>
            <div className="col-8">&nbsp;</div>
          </div>
        </form>
      </ModalWrapper>
    );
  }
}

export default reduxForm({
  form: 'customDateForm'
})(MICustomDateRange);
